import request from './request.js';

export function getPxInfo(keyScrent) {
  return request({
    url: `/px/info/getPxInfoByKeyScrent/${keyScrent}`,
    method: 'get',
  });
}
export function getPxInfoBySignToken(signToken) {
  return request({
    url: `/px/info/getPxInfoBySignToken/${signToken}`,
    method: 'get',
  });
}
export function getRoomInfo(keyScrent) {
  return request({
    url: `/px/info/getRoomInfoByKeyScrent/${keyScrent}`,
    method: 'get',
  });
}
export function getShadRoomInfo(keyScrent, isShadowMode) {
  return request({
    url: `/px/info/getRoomInfoByKeyScrent/${keyScrent}?isShadowMode=${isShadowMode}`,
    method: 'get',
  });
}
export function GenerateQRode(pxInfo) {
  return request({
    url: '/px/info/GenerateQRode',
    method: 'post',
    data: pxInfo,
  });
}

// 上传照片接口
export function uploadPhoto(formData, keyScrent) {
  return request({
    url: `/px/info/upload/${keyScrent}`,
    method: 'post',
    data: formData,
  });
}

export function verifyRoomAuth(keyScrent, name, phone) {
  return request({
    url: `/px/info/verifyRoomAuth/${keyScrent}`,
    method: 'post',
    data: { name, phone },
  });
}

export function checkAgentInviteCode(inviteCode) {
  return request({
    url: `/px/agent/invite/check/${inviteCode}`,
    method: 'get',
  });
}

export function submitAgentInvite(inviteCode, name, phone) {
  return request({
    url: `/px/agent/invite/submit/${inviteCode}`,
    method: 'post',
    data: { name, phone },
  });
}

export function getAgentInviteList(inviteCode) {
  return request({
    url: `/px/agent/invite/list/${inviteCode}`,
    method: 'get',
  });
}

export function getScanLogByKeyScrent(keyScrent, scanType) {
  return request({
    url: `/px/scanLog/getScanLogByKeyScrent`,
    method: 'get',
    params: { keyScrent, scanType },
  });
}
